export default {
  meta: {
    title: '小天才项目报告 PDF',
  },
};
